import { render, staticRenderFns } from "./purchaseRow.vue?vue&type=template&id=4eef8dfc&scoped=true&"
import script from "./purchaseRow.vue?vue&type=script&lang=js&"
export * from "./purchaseRow.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRow.vue?vue&type=style&index=0&id=4eef8dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eef8dfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
